import { Color } from './color';
/**
 * ■
 */
export const Square = (options, context) => {
    return Color(Object.assign({ colorAttribute: 'fill', symbol: 'square' }, options), context);
};
Square.props = Object.assign({ defaultMarker: 'square' }, Color.props);
//# sourceMappingURL=square.js.map